import { Component, OnInit, ViewContainerRef, ViewChild } from "@angular/core";
import { Pipe, PipeTransform } from "@angular/core";
import {
  DomSanitizer,
  SafeHtml,
  SafeStyle,
  SafeScript,
  SafeUrl,
  SafeResourceUrl
} from "@angular/platform-browser";
import { AuthService } from "src/app/services/auth.service";
import { ColorPickerService, Cmyk } from "ngx-color-picker";
import { NgxFaviconService } from "ngx-favicon";
import { Title } from "@angular/platform-browser";
import Swal from "sweetalert2";

@Pipe({
  name: "safe"
})
export class SafePipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) {}

  public transform(
    value: any,
    type: string
  ): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    switch (type) {
      case "html":
        return this.sanitizer.bypassSecurityTrustHtml(value);
      case "style":
        return this.sanitizer.bypassSecurityTrustStyle(value);
      case "script":
        return this.sanitizer.bypassSecurityTrustScript(value);
      case "url":
        return this.sanitizer.bypassSecurityTrustUrl(value);
      case "resourceUrl":
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
      default:
        throw new Error(`Invalid safe type specified: ${type}`);
    }
  }
}

@Component({
  selector: "app-personalizacion",
  templateUrl: "./personalizacion.component.html",
  styleUrls: ["./personalizacion.component.scss"]
})
export class PersonalizacionComponent implements OnInit {
  // Colors
  public primaryColor = "#e5703a";
  public secondaryColor = "#ff8200";
  public tertiaryColor = "#ffc107";
  public color1: any;
  public color2: any;
  public cmykValue: any;
  public cmykColor: any;

  // Cards
  public primaryCardColor = "#e5703a";
  public secondaryCardColor = "#ff8200";
  public CardDate = new Date();
  public hover: any;
  public hover1: any;
  public hover2: any;

  // Text
  public empresa = "MiCovinoc";

  // Favicon
  public toggleFavicon = true;
  // Toogles
  public toggleColor = true;
  public toggleTitulo = true;
  public toggleLogo = true;
  public toggleFondo = true;
  public toggleReestablecer = true;
  public toggleTabs = "demo3";

  // Title
  public SiteTitle = "MiCovinoc";
  public PageTitle = "Ajustes";
  public testCodigo = 123456;

  // Files
  public fileValueLogo = "Buscar Logo";
  public fileValueFavicon = "Buscar Favicon";
  public fileValueFondo = "Buscar fondo";
  public imagePathBackground: any;
  public imgURLBackground = "";
  public imagePathLogo: any;
  public imgURLLogo = "";
  public imagePathFavicon: any;
  public imgURLFavicon = "";
  public logoSeleccionado = "";
  public faviconSeleccionado = "";
  public fondoSeleccionado = "";

  public enviar = false;
  public text = "Para guardar los cambios, actualice a la ";

  // Angular
  @ViewChild("inputFileValue") inputFileValue: any;

  constructor(
    private auth: AuthService,
    private sanitizer: DomSanitizer,
    public vcRef: ViewContainerRef,
    private cpService: ColorPickerService,
    private titleService: Title
  ) {
    this.auth.show();
    this.setTitle(`${this.SiteTitle} | ${this.PageTitle}`);
  }

  ngOnInit() {}

  // Colors
  onChangeColorPrimary($event: any) {
    this.primaryColor = $event;
  }

  onChangeColorSecondary($event: any) {
    this.secondaryColor = $event;
  }

  onChangeColorTertiary($event: any) {
    this.tertiaryColor = $event;
  }

  // Cards colors
  onChangeColorCardPrimary($event: any) {
    this.primaryCardColor = $event;
  }

  onChangeColorCardSecondary($event: any) {
    this.secondaryCardColor = $event;
  }

  // Title
  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  //
  OnChangeColor(check: any) {
    this.Validar();
    if (check === true) {
      this.primaryColor = "#fff";
      this.secondaryColor = "#fff";
    } else {
      this.primaryColor = "#e5703a";
      this.secondaryColor = "#ff8200";
    }
  }

  OnChangeTitle(check: any) {
    this.Validar();
    if (check === true) {
      this.empresa = "";
    } else {
      this.empresa = "MiCovinoc";
      this.setTitle(this.empresa);
    }
  }

  OnChangeLogo(check: any) {
    this.Validar();
    if (check === true) {
      this.logoSeleccionado = "";
    }
  }

  OnChangeFondo(check: any) {
    this.Validar();
    if (check === true) {
      this.fileValueFondo = "Buscar fondo";
      this.fondoSeleccionado = "";
    }
  }

  OnChangeReestablecer(check: any) {
    this.Validar();
    this.OnChangeColor(check);
    if (check === true) {
      this.toggleColor = true;
      this.toggleTitulo = true;
      this.toggleLogo = true;
      this.toggleFavicon = true;
      this.toggleFondo = true;
    } else {
      this.toggleColor = false;
      this.toggleTitulo = false;
      this.toggleLogo = false;
      this.toggleFavicon = false;
      this.toggleFondo = false;
    }
  }

  seleccionLogo(archivo: File, event: any) {
    this.fileValueLogo = archivo.name;
    const fileReader = new FileReader();
    fileReader.onload = async e => {
      this.logoSeleccionado = fileReader.result as string;
    };
    fileReader.readAsDataURL(event.target.files[0]);
  }

  seleccionFavicon(archivo: any) {
    this.fileValueFavicon = archivo[0].name;

    if (archivo.length === 0) {
      return;
    }

    const mimeType = archivo[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = "Only images are supported.";
      return;
    }

    const reader = new FileReader();
    this.imagePathFavicon = archivo;
    reader.readAsDataURL(archivo[0]);
    reader.onload = (Event: any) => {
      this.imgURLFavicon = reader.result as string;
      this.faviconSeleccionado = this.imgURLFavicon;
    };
  }

  seleccionFondo(archivo: any) {
    this.fileValueFondo = archivo[0].name;

    if (archivo.length === 0) {
      return;
    }

    const mimeType = archivo[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = "Only images are supported.";
      return;
    }

    const reader = new FileReader();
    this.imagePathBackground = archivo;
    reader.readAsDataURL(archivo[0]);
    reader.onload = (Event: any) => {
      this.imgURLBackground = reader.result as string;
      this.fondoSeleccionado = this.imgURLBackground;
    };
  }

  ToggleTabs(estado: string) {
    this.toggleTabs = estado;
  }

  Validar() {
    if (
      this.toggleColor === false ||
      this.toggleTitulo === false ||
      this.toggleLogo === false ||
      this.toggleFavicon === false ||
      this.toggleFondo === false
    ) {
      this.enviar = false;
    } else {
      this.enviar = true;
    }
  }

  GuardarAjustes() {
    Swal.fire({
      type: "info",
      title: "¡Para guardar ajustes, actualice su plan!",
      text: "Por tan sólo $ xxxxxxx"
    });
  }
}
